// Light/dark theme switch (persisted in localStorage; applied early in partials/head.latte).
import { store } from './store.js';

export function initTheme() {
	const html = document.documentElement;

	const toggle = () => {
		const current = html.getAttribute('data-bs-theme') === 'dark' ? 'dark' : 'light';
		const next = current === 'dark' ? 'light' : 'dark';
		html.setAttribute('data-bs-theme', next);
		store.set('genus-theme', next);
	};

	document.querySelectorAll('[data-theme-toggle]').forEach((btn) => btn.addEventListener('click', toggle));
}
